import Link from "next/link";
import type { ComponentProps } from "react";
import { isPlainAnchorHref, opensInNewTab } from "@/lib/href";

type HrefLinkProps = Omit<ComponentProps<"a">, "href"> & { href: string };

export default function HrefLink({
  children,
  href,
  rel,
  ...props
}: HrefLinkProps) {
  if (opensInNewTab(href)) {
    return (
      <a
        href={href}
        rel={rel ?? "noopener noreferrer"}
        // oxlint-disable-next-line react/jsx-no-target-blank -- rel is always set; article links pass noopener to keep the referrer
        target="_blank"
        {...props}
      >
        {children}
      </a>
    );
  }
  if (isPlainAnchorHref(href)) {
    return (
      <a href={href} rel={rel} {...props}>
        {children}
      </a>
    );
  }
  return (
    <Link href={href} rel={rel} {...props}>
      {children}
    </Link>
  );
}
